exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.cell{display:flex;flex-direction:column}.cell .cell-text{font-size:14px;color:#4a4a4a;font-family:Open Sans,sans-serif;text-overflow:ellipsis;overflow:hidden;margin-left:14px}.cell .cell-text p{padding:0;margin:0}.cell.closeout-created_at .cell{flex-direction:row;align-items:center;justify-content:flex-start;margin-left:14px}.cell.closeout-created_at .cell .users-options{zoom:.6;margin-top:3px;height:19px;cursor:pointer}.cell.closeout-created_at .cell .cell-text{margin-left:unset}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/Table/TableRow/TableRowCell/TableRowCell.scss
// module id = 1626
// module chunks = 0